import React from 'react';
import AssetOptions from '../../AssetOptions/AssetOptions';
import ViewOnlyWarning from '../../ViewOnlyWarning/ViewOnlyWarning';
import MultipleAgreements from '../../MultipleAgreements/MultipleAgreements';
import ModifiedBuyCard from '../../../../getty/logicalComponents/ModifiedBuyCard/ModifiedBuyCard';
import MiniDownloadHistory from '../../MiniDownloadHistory/MiniDownloadHistory';
import ProjectCodes from '../../ProjectCodes/ProjectCodes';
import Notes from '../../Notes/Notes';
import DownloadMessage from '../../Messages/DownloadMessage/DownloadMessage';
import useMode from '../../../../hooks/stateful/useMode';
import acquisitionMode from '../../../../support/acquisitionMode';
import UsageRestrictionsWarning from '../../UsageRestrictionsWarning/UsageRestrictionsWarning';
import { ModifiedDownloadInProgress } from '../../../../shared/molecules/ModifiedDownloadInProgress';
import WarningBox from '../../../WarningBox/WarningBox';
import { useAcquisitionType } from '../../../../hooks/stateful/useAcquisitionType';
import acquisitionTypes from '../../../../support/acquisitionTypes';
import useModifiedDownload from '../../../../hooks/useModifiedDownload';
import { DownloadStatus } from '../../../../../types/isomorphic/downloadRequest.types';

const ModifiedDownloadForm = () => {
  const { mode } = useMode();
  const { acquisitionType, acquisitionViewStack } = useAcquisitionType();
  const { modifiedAssetDownloadData } = useModifiedDownload();

  // This form also backs the in-progress view. The A La Carte flow reaches it
  // from the license-redownload view, which is the one that shows the royalty-
  // free license benefits.
  if (acquisitionType === acquisitionTypes.MODIFIED_DOWNLOAD_IN_PROGRESS) {
    const previousView = acquisitionViewStack[acquisitionViewStack.length - 2];
    const showLicenseBenefits =
      previousView === acquisitionTypes.MODIFIED_LICENSE_REDOWNLOAD;
    const isFailed =
      modifiedAssetDownloadData?.status === DownloadStatus.FAILED;

    return (
      <div data-testid="modified-download-form">
        {isFailed ? (
          <WarningBox />
        ) : (
          <ModifiedDownloadInProgress
            showLicenseBenefits={showLicenseBenefits}
          />
        )}
      </div>
    );
  }

  return (
    <div data-testid="modified-download-form">
      <AssetOptions />
      <DownloadMessage />
      {mode === acquisitionMode.MODAL && <UsageRestrictionsWarning />}
      <ViewOnlyWarning />
      <MultipleAgreements />
      <ModifiedBuyCard priced={false} />
      <MiniDownloadHistory />
      <ProjectCodes />
      <Notes />
    </div>
  );
};

export default ModifiedDownloadForm;
